import { useEffect, useState } from 'react';
import { hasPlayableVideo } from '../components/videoCallPresentation';

export function useVideoTrackAvailability(stream: MediaStream | null) {
  const [, refresh] = useState(0);
  useEffect(() => {
    if (!stream) return;
    const changed = () => refresh((value) => value + 1);
    const watched = new Set<MediaStreamTrack>();
    const syncTracks = () => {
      for (const track of stream.getVideoTracks()) {
        if (watched.has(track)) continue;
        watched.add(track);
        track.addEventListener('ended', changed);
        track.addEventListener('mute', changed);
        track.addEventListener('unmute', changed);
      }
      changed();
    };
    stream.addEventListener('addtrack', syncTracks);
    stream.addEventListener('removetrack', syncTracks);
    syncTracks();
    return () => {
      stream.removeEventListener('addtrack', syncTracks);
      stream.removeEventListener('removetrack', syncTracks);
      for (const track of watched) {
        track.removeEventListener('ended', changed);
        track.removeEventListener('mute', changed);
        track.removeEventListener('unmute', changed);
      }
    };
  }, [stream]);
  return hasPlayableVideo(stream);
}
